import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_TYPE_COLORS } from '@/types/docflow';
import type { INodeConfig } from '@/types/docflow';

interface OutputDesignerNodeProps {
  data: {
    label: string;
    config: INodeConfig;
    selected?: boolean;
  };
}

const OutputDesignerNode = memo(({ data }: OutputDesignerNodeProps) => {
  const colors = NODE_TYPE_COLORS.output_designer;
  const fieldCount = data.config.fields?.length || 0;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] max-w-[220px] ${colors.bg} ${colors.border} ${
        data.selected ? 'ring-2 ring-amber-400' : ''
      }`}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 !bg-amber-500"
      />

      <div className="flex items-center gap-2 mb-2">
        <svg className={`w-5 h-5 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${colors.badge}`}>
          Output Designer
        </span>
      </div>

      <h4 className={`font-medium text-sm mb-1 ${colors.text}`}>
        {data.label}
      </h4>

      {data.config.template_name && (
        <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">
          {data.config.template_name}
        </div>
      )}

      <div className="text-xs text-gray-500 dark:text-gray-400">
        {fieldCount} field{fieldCount !== 1 ? 's' : ''}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 !bg-amber-500"
      />
    </div>
  );
});

OutputDesignerNode.displayName = 'OutputDesignerNode';

export default OutputDesignerNode;
